import { createElement as rc, useCallback } from 'react';
import useEventSink from '../../hooks/useEventSink';
import useActiveRecord from '../../hooks/useActiveRecord';
import { Button } from 'lib_ui-primitives';
import useFormContext from '../../hooks/useFormContext';
import { isDisabled } from './helpers';
const _p = {
    useFormContext,
    useActiveRecord
};

// @ts-ignore
/** @typedef {import('../../hooks/useFormMachine').FormContext} FormContext */

export const _private = _p;
export default function FormHeaderButton(props) {
    const {
        hNode,
        hNode: { formAction: _formAction, title: hTitle, buttonStyle, id, subtype = '', iconName, displayTitleOnButton },
        value,
        text,
        title,
        children,
        actionPayload,
        ...otherProps
    } = props;
    //UI 1.x.x required  different actions for everything.
    //UI 2.x.x is more flexible, and is most powerful when using as few as possible.
    // treat "print" as "submit":
    const formAction = _formAction === 'print' ? 'submit' : _formAction;

    /** @type {FormContext} */
    const context = _p.useFormContext();
    const [, publish] = useEventSink();
    const activeRecord = _p.useActiveRecord();
    const namespace = hNode.namespace || activeRecord.namespace;
    const relation = hNode.relation || activeRecord.relation;
    const type = hNode.type || activeRecord.type;
    const formInstanceId = activeRecord.formInstanceId;
    const record = actionPayload?.record || context.newRecord || activeRecord.record;

    const onClick = useCallback(() => {
        // Include the same formInstanceId as a regular form button. ActiveRecord can
        // then ignore a cancel that finishes after another form opens.
        publish(
            { record },
            { verb: formAction, namespace, relation, type: subtype || type, formInstanceId },
            { debugDetail: 'FormHeaderButton', enqueueHandlers: false, bubbleAlways: false, preventBubble: false, waitForSubscriber: true }
        );
    }, [namespace, relation, record, type, formInstanceId, subtype, publish, formAction]);

    return rc(Button, {
        id,
        hNode,
        text: displayTitleOnButton === false ? undefined : (text ?? value ?? title ?? hTitle),
        icon: iconName,
        buttonStyle,
        onClick,
        disabled: isDisabled(context, formAction),
        ...otherProps
    }, displayTitleOnButton === false ? null : children);
}
